import { z } from 'zod';
import { IsoTimestamp } from './common';

export const UserSuspension = z.object({
  userId: z.string(),
  reason: z.string().min(1).max(500),
  suspendedByEmail: z.string().email(),
  suspendedByUserId: z.string(),
  suspendedAt: IsoTimestamp,
  expiresAt: IsoTimestamp.optional(),
});
export type UserSuspension = z.infer<typeof UserSuspension>;

export const SuspendUserRequest = z.object({
  reason: z.string().min(1).max(500),
  expiresAt: IsoTimestamp.optional(),
});
export type SuspendUserRequest = z.infer<typeof SuspendUserRequest>;
